// Helpers de data. Sempre via date-fns — nunca Date math direto.
import { formatDistanceToNow, format, parseISO, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatRelativeDate(input: Date | string): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  if (!isValid(date)) return '';
  return formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
}

export function formatDate(input: Date | string, pattern = "dd/MM/yyyy 'às' HH:mm"): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  if (!isValid(date)) return '';
  return format(date, pattern, { locale: ptBR });
}

export function toISOString(input: Date | string): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  return isValid(date) ? date.toISOString() : '';
}
